<template>
  <div style="border: 1px solid #ebedf3; background-color: #fff;">
    <ul
      class="nav nav-tabs nav-bold nav-tabs-line px-5 pt-3"
      style="border-bottom: 1px solid #ebedf3;"
    >
      <li class="nav-item">
        <a
          class="nav-link"
          :class="{ active: activeTab === 'midterm' }"
          href="javascript:;"
          @click="changeTab('midterm')"
        >
          Thi giữa khóa & cuối khóa
        </a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          :class="{ active: activeTab === 'entrance' }"
          href="javascript:;"
          @click="changeTab('entrance')"
        >
          Thi đầu khóa
        </a>
      </li>
    </ul>

    <div class="tab-content">
      <ExamIndex v-if="activeTab === 'midterm'" />
      <StudentExamResultList v-if="activeTab === 'entrance'" />
    </div>
  </div>
</template>

<script>
import ExamIndex from '@/view/pages/exam/ExamIndex.vue';
import StudentExamResultList from '@/view/pages/entrance-manage/StudentExamResultList.vue';

const VALID_TABS = ['midterm', 'entrance'];

export default {
  name: 'ExamManageTabs',
  components: {
    ExamIndex,
    StudentExamResultList,
  },
  data() {
    return {
      activeTab: 'midterm',
    };
  },
  watch: {
    '$route.query.tab': {
      immediate: true,
      handler(tab) {
        if (VALID_TABS.includes(tab)) {
          this.activeTab = tab;
        } else if (tab) {
          this.syncTabQuery(this.activeTab);
        }
      },
    },
  },
  methods: {
    changeTab(tab) {
      if (this.activeTab === tab) {
        return;
      }
      this.activeTab = tab;
      this.syncTabQuery(tab);
    },
    syncTabQuery(tab) {
      const query = { ...this.$route.query };
      if (tab === 'midterm') {
        delete query.tab;
      } else {
        query.tab = tab;
      }
      this.$router.replace({
        name: 'exam-index',
        query,
      }).catch(() => {});
    },
  },
};
</script>
